'use strict';

export { default as updateProps } from "./updateProps.js";
export { updatePropsJestWrapper } from "./updateProps.js";
//# sourceMappingURL=index.js.map